import { Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-preview',
  templateUrl: './icon-preview.component.html',
  styleUrls: ['./icon-preview.component.scss'],
})
export class IconPreviewComponent {}
